import { render, staticRenderFns } from "./CategoryList.vue?vue&type=template&id=554f6254&scoped=true"
import script from "./CategoryList.vue?vue&type=script&lang=ts"
export * from "./CategoryList.vue?vue&type=script&lang=ts"
import style0 from "./CategoryList.vue?vue&type=style&index=0&id=554f6254&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554f6254",
  null
  
)

export default component.exports